module.exports = __webpack_public_path__ + "static/img/慢病毒包装banner.4790157.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/二级标题Banner/慢病毒包装banner.jpg
// module id = inOo
// module chunks = 1